export default function BasketFixedRenewLogic(
    $q,
    moment,
    Bookings,
    BookingPeriods,
    Log
) {
    var fn = this;

    fn.anyPeriodsAvailableWithinMaxBookingDays = (periods) => {
        const approved = periods.filter((period) => {
            let maxBookingDays = period._resource.maxBookingDays;

            const availableWithinMaxBookingDays = maxBookingDays
                ? moment(period.start).isSameOrBefore(
                      moment().add(maxBookingDays, "days"),
                      "day"
                  )
                : true;

            return period.isAvailable && availableWithinMaxBookingDays;
        });

        return approved.length ? $q.resolve(true) : $q.resolve(false);
    };

    fn.isPriorPeriodOwnedByUser = (priorPeriod, userId) => {
        if (priorPeriod.bookingPeriodId) {
            return BookingPeriods.get(priorPeriod.bookingPeriodId).then(
                (period) => {
                    return Bookings.get(period.bookingId)
                        .then((booking) => {
                            const maxBookingDays =
                                period.resource.maxBookingDays;

                            if (
                                moment(period.start).isSameOrAfter(
                                    moment().add(maxBookingDays, "days"),
                                    "day"
                                )
                            ) {
                                if (userId == booking.userId) {
                                    return booking.id;
                                }
                            }
                            return false;
                        })
                        .catch((error) => {
                            Log.string(
                                "isPriorPeriodOwnedByUser - statusText",
                                error.statusText
                            );
                            return false;
                        });
                }
            );
        }

        return $q.resolve(false);
    };

    return fn;
}
